export default "__VITE_ASSET__4f4b85d9__"